import React, { useContext, useEffect, useState } from "react";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import { useParams } from "react-router-dom";
import IWarehouse_Transfer from "../../../models/IWarehouse_Transfer";
import IGetWarehouseTransferDTO from "../../../models/DTO/IGetWarehouseTransferDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetWarehouseTransferDTO from "../../../models/DTO/IOnGetWarehouseTransferDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import styled from "styled-components";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IWarehouse_Transfer_Catalog_Item_Map from "../../../models/IWarehouse_Transfer_Catalog_Item_Map";
import IOwTableCols from "../../../models/IOwTableCols";
import OwTable from "../../shared/OwTable/OwTable";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

export const TransferSlip = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    // @ts-expect-error
    const { guid } = useParams();

    const [warehouseTransfer, setWarehouseTransfer] = useState<IWarehouse_Transfer | null>(null);
    const [warehouseTransferItems, setWarehouseTransferItems] = useState<IWarehouse_Transfer_Catalog_Item_Map[]>([]);
    const [tableCols, setTableCols] = useState<IOwTableCols[]>([]);
    const [isDataFetching, setIsDataFetching] = useState<boolean>(true);
    const [isInitialData, setIsInitialData] = useState<boolean>(true);
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbs[]>([
        { title: "transfers", url: "/inventory/transfers" },
        { title: "transfer", url: `/inventory/transfers/${guid}` },
        { title: "slip", url: `/inventory/transfers/${guid}/slip` },
    ]);

    const getTableCols = (): IOwTableCols[] => {
        return [
            { title: "name", valueProp: "Catalog_Item", valueSubProp: "name" },
            { title: "sku", valueProp: "Catalog_Item", valueSubProp: "sku" },
            { title: "sent_qty", valueProp: "sent_qty" },
        ];
    };

    const getTransfer = () => {
        if (guid) {
            const payload: IGetWarehouseTransferDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                warehouseTransferGuid: guid,
            };

            socket.emit(EndpointsEnum.WarehouseGetTransfer, payload);

            setIsDataFetching(true);
        }
    };

    const onGetTransfer = (data: IOnGetWarehouseTransferDTO) => {
        setWarehouseTransfer(data.warehouseTransfer);
        setWarehouseTransferItems(data.warehouseTransfer.Warehouse_Transfer_Catalog_Items_Maps || []);

        setIsDataFetching(false);
        setIsInitialData(false);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.WarehouseOnGetTransfer, fn: onGetTransfer }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getTransfer();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        setTableCols(getTableCols());
    }, [warehouseTransferItems]);

    return (
        <div className={"TransferSlip"}>
            <Breadcrumbs crumbs={breadcrumbs} />
            <div className={"text-end"}>
                <OwPrintButton />
            </div>
            <div className="row">
                <div className="col-12">
                    <h1>Transfer Slip</h1>
                </div>
            </div>

            <div className={"d-flex align-items-center"}>
                <div className={"w-15r"}>
                    <OwTitle title={"origin"} tag={"h3"} />
                    {warehouseTransfer?.Origin_Warehouse?.name}
                    <AddressDisplay address={warehouseTransfer?.Origin_Warehouse?.Address} />
                </div>

                <CenterIcon>
                    <i className={"fal fa-truck-arrow-right"}></i>
                </CenterIcon>

                <div className={"w-15r"}>
                    <OwTitle title={"destination"} tag={"h3"} />
                    {warehouseTransfer?.Destination_Warehouse?.name}
                    <AddressDisplay address={warehouseTransfer?.Destination_Warehouse?.Address} />
                </div>
            </div>

            <div>
                <OwTable
                    columns={tableCols}
                    dataSet={warehouseTransferItems}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                />
            </div>
        </div>
    );
};

const CenterIcon = styled.div`
    font-size: 2rem;
    width: 10rem;
`;
